import { render } from "./Vnud-Dashboard.vue?vue&type=template&id=7c6b323e"
import script from "./Vnud-Dashboard.vue?vue&type=script&lang=js"
export * from "./Vnud-Dashboard.vue?vue&type=script&lang=js"

import "./Vnud-Dashboard.vue?vue&type=style&index=0&id=7c6b323e&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Plataforma_eventos\\registar-evento\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__